import script from "./SignUpComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=57e9ef5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e9ef5d"]])

export default __exports__